import { FormControlName } from 'domains/forms/forms.types'
import { useFormControl } from 'domains/forms/hooks'
import { useI18n } from 'domains/i18n/hooks'
import { className } from 'lib/css'
import { FC } from 'preact/compat'
import FileInput from 'ui/components/form-controls/file-input'
import Form from 'ui/components/form-controls/form'

type FileInputFormProps = {
  controlName: FormControlName
  skiplinkId: string
  accept: string
  contentHint: string
  isComplete: boolean
  isUploading: boolean
  onClickCancel: () => void
}

const FileInputForm: FC<FileInputFormProps> = ({
  skiplinkId,
  controlName,
  accept,
  contentHint,
  isUploading,
  isComplete,
  onClickCancel,
}) => {
  const { t } = useI18n()
  const [{ value: fileList }] = useFormControl(controlName)
  const hasFile = fileList && fileList.length > 0

  const selectedFileName =
    hasFile && typeof fileList !== 'string' ? fileList[0].name : ''

  return (
    <Form className={className('upload-form')}>
      <FileInput
        name={controlName}
        id={skiplinkId}
        accept={accept}
        labelText={t('fileUpload.labelText')}
        outputText={t('fileUpload.selectedText', {
          hasFile,
          filename: selectedFileName,
        })}
        contentHint={contentHint}
      />
      <div className={className('upload__button-container')}>
        <button
          id={isUploading || !isComplete ? skiplinkId : undefined}
          type="button"
          onClick={onClickCancel}
          className={className('button', 'button--secondary', 'upload__cancel')}
        >
          {t('fileUpload.cancelButtonText')}
        </button>
        <button
          className={className('button', 'button--primary')}
          type="submit"
        >
          {t('fileUpload.uploadButtonText')}
        </button>
      </div>
    </Form>
  )
}

export default FileInputForm
